
import { userService } from '../services/userService';

export function handleResponse(response) {

    return response.text().then(text => {
        let data = ''
         try {
            data =  JSON.parse(text);
        }  catch (e) {
            return Promise.reject(e);
        }


        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                userService.logout();
            }


            if (process.env.NODE_ENV === 'production') {
                let error = (data && data['api-error-msg']) ? data['api-error-msg']  : response.statusText;
                return Promise.reject(error);
            } else {

                const error = ((data && data['api-error-msg']) ? data['api-error-msg'] : response.statusText) +' <pre> '+ JSON.stringify(data,null,'\t')+'</pre>';
                return Promise.reject(error);
            }

            
        }

        //sprawdzamy czy poprawnie zalogowano
        if (data.status == 'ERROR') {
            const error = data.message
            return Promise.reject(error);
        }

        return data;
    });
}